'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = build;

var _rules = require('./rules');

var _rules2 = _interopRequireDefault(_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this function takes the rule configuration object and applies hover, 
// focus and active states and media queries to them

function build(opts) {
  if (process.env.NODE_ENV !== 'production') {
    if (!opts) throw new Error('you need to pass options to the "build()" function!');
    var missing = 'mediaQueries applyStates'.split(' ').filter(function (o) {
      return !opts[o];
    });
    if (missing.length) throw new Error('you need to pass "' + missing.join(', ') + '" within build options!');
  }
  var mediaQueries = opts.mediaQueries,
      applyStates = opts.applyStates;


  var rules = (0, _rules2.default)(opts);

  var combinedRules = [];

  Object.keys(rules).forEach(function (ruleName) {
    var ruleDefinitions = rules[ruleName];
    var ruleDefinitionKeys = Object.keys(ruleDefinitions);
    ruleDefinitionKeys.forEach(function (label) {
      combinedRules.push([label, {
        state: null,
        media: null,
        rule: ruleDefinitions[label]
      }]);
    });

    if (applyStates.indexOf(ruleName) > -1) {
      ['hover', 'focus', 'active'].forEach(function (state) {
        ruleDefinitionKeys.forEach(function (label) {
          var rule = ruleDefinitions[label];
          if (rule.$global) return;
          combinedRules.push([state + '-' + label, {
            state: state,
            media: null,
            rule: rule
          }]);
        });
      });
    }

    Object.keys(mediaQueries).forEach(function (mediaLabel) {
      ruleDefinitionKeys.forEach(function (label) {
        var rule = ruleDefinitions[label];
        if (rule.$global) return;
        combinedRules.push([label + '-' + mediaLabel, {
          state: null,
          media: mediaQueries[mediaLabel],
          rule: rule
        }]);
      });
    });
  });

  combinedRules.mediaQueries = mediaQueries;

  return combinedRules;
}


//////////////////
// WEBPACK FOOTER
// ./~/reta/rules-builder.js
// module id = 352
// module chunks = 0